import { cn, focusRing } from "@simpro/ui";
import { Moon, Sun } from "lucide-react";
import { useThemeStore } from "@/lib/theme.store";
import { usePageTheme } from "@/shared/hooks/usePageTheme";

/**
 * Light or dark in one tap, in the site header (Rosé Arch, design note
 * salon-booking-premium-redesign.md section 10): the moon in light, the sun in dark. It sets the
 * customer's own choice, which wins over the salon's (FR-SA-189) and is kept on the device; Auto
 * stays in Account → Preferences and the desktop footer.
 */
export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const dark = usePageTheme() === "dark";
  const setTheme = useThemeStore((state) => state.setTheme);
  const Icon = dark ? Sun : Moon;

  return (
    <button
      type="button"
      aria-label="Dark mode"
      aria-pressed={dark}
      onClick={() => setTheme(dark ? "light" : "dark")}
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full bg-surface text-heading ring-1 ring-edge-subtle transition-colors ring-inset hover:ring-edge",
        compact ? "size-9" : "size-11",
        focusRing,
      )}
    >
      <Icon className="size-[18px]" aria-hidden="true" />
    </button>
  );
}
